import roleWorkspaceService from '@/services/roleWorkspace.service';
import config from '@/config/prod.env';

const actions = {    
    async getByWorkspaceIdAndRoleIds({ dispatch }, obj) {
        return await roleWorkspaceService.getByWorkspaceIdAndRoleIds(obj.workspaceId, obj.roleIds);
    },
    
    async createRoleWorkspaceMultiple({ dispatch, commit }, obj) {
        let body = [];
        obj.roleIds.forEach(roleId => {
            body.push({
                workspaceId: obj.workspaceId, 
                roleId: roleId
            });
        });
        let res = await roleWorkspaceService.createMultiple(body);
        if(res.isOk) {
            dispatch("alert/success", "Cập nhật dữ liệu thành công", { root: true });
        } else {
            dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
            return false;
        }
    },

    async deleteByWorkspaceIdAndRoleIds({ dispatch }, obj) {
        return await roleWorkspaceService.deleteByWorkspaceIdAndRoleIds(obj.workspaceId, obj.roleIds);
    },
};

export const roleWorkspace = {
    namespaced: true,
    actions
};